var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshCcw02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-ccw-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66669 8.83333C1.66669 8.83333 1.76779 8.12563 4.69672 5.1967C7.62565 2.26777 12.3744 2.26777 15.3033 5.1967C16.341 6.23443 17.0111 7.5006 17.3135 8.83333M1.66669 8.83333V3.83333M1.66669 8.83333H6.66669M18.3334 12.1667C18.3334 12.1667 18.2323 12.8744 15.3033 15.8033C12.3744 18.7322 7.62565 18.7322 4.69672 15.8033C3.65899 14.7656 2.98893 13.4994 2.68654 12.1667M18.3334 12.1667V17.1667M18.3334 12.1667H13.3334",
    stroke: "#101828",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCcw02);
export default __webpack_public_path__ + "static/media/refresh-ccw-02.ad82c867163e4eb1f0b5553b2c9bcab2.svg";
export { ForwardRef as ReactComponent };